import api from './api';
import { AuthResponse, LoginCredentials, User, UserRole } from '../types';

export const authService = {
  async login(credentials: LoginCredentials, userType?: UserRole): Promise<AuthResponse> {
    const endpoint =
      userType === 'associate'
        ? '/associados/login'
        : userType === 'dependent'
        ? '/dependentes/login'
        : '/login';

    // Para login de admin, inclui o system_id do .env
    const payload =
      userType === 'associate' || userType === 'dependent'
        ? credentials
        : { ...credentials, system_id: process.env.REACT_APP_SYSTEM_ID };

    const response = await api.post<AuthResponse>(endpoint, payload);
    return response.data;
  },

  async getUser(): Promise<User> {
    const response = await api.get<User>('/user/me');
    return response.data;
  },

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  saveAuth(data: AuthResponse): void {
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
  },

  getStoredUser(): User | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  getStoredToken(): string | null {
    return localStorage.getItem('token');
  },

  isAuthenticated(): boolean {
    return !!this.getStoredToken();
  },

  async forgotPassword(email: string, userType: UserRole): Promise<{ message: string }> {
    const endpoint =
      userType === 'associate'
        ? '/associados/forgot-password'
        : userType === 'dependent'
        ? '/dependentes/forgot-password'
        : '/forgot-password';
    const response = await api.post<{ message: string }>(endpoint, { email });
    return response.data;
  },

  async resetPassword(token: string, password: string, password_confirmation: string, userType: UserRole): Promise<{ message: string }> {
    const endpoint =
      userType === 'associate'
        ? '/associados/reset-password'
        : userType === 'dependent'
        ? '/dependentes/reset-password'
        : '/reset-password';
    const response = await api.post<{ message: string }>(endpoint, {
      token,
      password,
      password_confirmation
    });
    return response.data;
  },

  /**
   * Primeiro acesso do dependente: define a senha de um cadastro que foi
   * criado sem senha. Já retorna token/user, como um login normal.
   */
  async setDependentPassword(data: {
    cpf?: string;
    email?: string;
    password: string;
    password_confirmation: string;
  }): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/dependentes/set-password', data);
    return response.data;
  }
};
